import JobQualification from ".";

export const jobQualificationRoutes = () => [
  {
    path: "/admin/job-qualifications",
    component: JobQualification,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];
